import { apolloClient } from "@/plugins/vue-apollo.js";

const toggleBlockStatus = (_variables) => {
  let responseFromApi;
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/blocks/toggle_block_status.graphql"),
      variables: _variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/blocks/block_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          },
        };
        store.writeQuery({
          ...query,
          data: data,
        });
      },
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { toggleBlockStatus };
